// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
import { z } from 'zod';
import { BaseErrorSchema } from '../../shared/error.schema';
import { ProcessChainSchema, ProcessSwimlaneMappingSchema } from '../../entities/process-chain/process-chain.schema';
import { ErrorCode } from '../../shared/error-codes';
// TODO: Review AI Code for feature: Process Map - Entire file is AI-generated
/**
 * Create Process Chain Request Schema
 * POST /api/v2/process-chains
 */ export const CreateProcessChainRequestSchema = ProcessChainSchema.omit({
    _id: true,
    createdBy: true,
    createdAt: true,
    updatedAt: true
}).extend({
    name: z.string().min(1, ErrorCode.FIELD_REQUIRED),
    processSwimlaneMappings: z.array(ProcessSwimlaneMappingSchema).default([])
});
/**
 * Create Process Chain Response Schema
 */ export const CreateProcessChainResponseSchema = z.object({
    processChain: ProcessChainSchema
});
export const CreateProcessChainErrorSchema = BaseErrorSchema;

//# sourceMappingURL=create-process-chain.schema.js.map